module.exports = __webpack_public_path__ + "static/media/menu-search.29fac5c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Images/menu-search.svg
// module id = 212
// module chunks = 2